module.exports = "<section class=\"loaders\">\r\n  <img src=\"assets/images/loader.gif\" />\r\n</section>"